import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { Container } from "@snapchat/snap-design-system";

type AlignOptions =
    | "normal"
    | "stretch"
    | "center"
    | "start"
    | "end"
    | "flex-start"
    | "flex-end"
    | "self-start"
    | "self-end"
    | "baseline"
    | "first baseline"
    | "last baseline"
    | "safe center"
    | "unsafe center";

type JustifyContentOptions =
    | "center"
    | "start"
    | "end"
    | "flex-start"
    | "flex-end"
    | "left"
    | "right"
    | "space-between"
    | "space-around"
    | "space-evenly"
    | "stretch"
    | "safe center"
    | "unsafe center";

type FlexWrapOptions = "nowrap" | "wrap" | "wrap-reverse" | "inherit" | "initial" | "revert" | "revert-layer" | "unset";

const getFlexProps = (props: FlexboxProps) => css`
    display: flex;
    flex-direction: ${props.flexDirection};
    align-items: ${props.alignItems};
    justify-content: ${props.justifyContent};
    flex-shrink: ${props.flexShrink};
    flex: ${props.flex};
    flex-wrap: ${props.flexWrap};
    flex-grow: ${props.flexGrow};
    flex-basis: ${props.flexBasis};

    > *:not(:first-of-type) {
        margin: ${props.itemMargin};
    }
`;

export interface FlexboxProps {
    flex?: string;
    flexBasis?: string;
    flexGrow?: number;
    flexShrink?: number;
    flexDirection?: "row" | "row-reverse" | "column" | "column-reverse";
    flexWrap?: FlexWrapOptions;
    alignItems?: AlignOptions;
    justifyContent?: JustifyContentOptions;
    itemMargin?: string;
}

export const Flexbox = styled("div")(getFlexProps);
export const FlexContainer = styled(Container)(getFlexProps);
export const FlexSection = Flexbox.withComponent("section");
